import { GetterTree } from 'vuex';
import RootState from '@/types/store/booking/RootState';
import AuthState from '@/types/store/auth/AuthState';

const getters: GetterTree<AuthState, RootState> = {};

export default getters;
